export default "__VITE_ASSET__jyNtGytW__"